import $http from '@/plugins/axios'
import { removeNamespace } from '@/utils/helpers'

export const IMPRINT_DISCOUNTS_TYPES = {
  mutations: {
    SET_LOADING: 'imprintDiscounts/SET_LOADING',
    SET_PAGED_IMPRINT_DISCOUNTS: 'imprintDiscounts/SET_PAGED_IMPRINT_DISCOUNTS',
    SET_TOTAL_IMPRINT_DISCOUNTS_COUNT: 'imprintDiscounts/SET_TOTAL_IMPRINT_DISCOUNTS_COUNT',
    SET_IMPRINTS: 'imprintDiscounts/SET_IMPRINTS',
    SET_DISCOUNT_CODES: 'imprintDiscounts/SET_DISCOUNT_CODES',
    SET_TABLE_OPTIONS: 'imprintDiscounts/SET_TABLE_OPTIONS',
    SET_SEARCH_OPTIONS: 'imprintDiscounts/SET_SEARCH_OPTIONS',
    SET_IMPRINT_FILTER: 'imprintDiscounts/SET_IMPRINT_FILTER',
    SET_DISCOUNT_CODE_FILTER: 'imprintDiscounts/SET_DISCOUNT_CODE_FILTER'
  },
  actions: {
    fetchImprintDiscountsPaged: 'imprintDiscounts/fetchImprintDiscountsPaged',
    fetchImprints: 'imprintDiscounts/fetchImprints',
    fetchDiscountCodes: 'imprintDiscounts/fetchDiscountCodes',
    changeImprintFilter: 'imprintDiscounts/changeImprintFilter',
    changeDiscountCodeFilter: 'imprintDiscounts/changeDiscountCodeFilter'
  }
}

const _types = removeNamespace('imprintDiscounts', IMPRINT_DISCOUNTS_TYPES)

const state = () => ({
  loading: false,
  tableOptions: {
    page: 1,
    itemsPerPage: 10
  },
  searchOptions: {
    keyword: '',
    imprintFilter: '',
    discountCodeFilter: ''
  },
  pagedImprintDiscounts: [],
  totalImprintDiscountsCount: 0,
  imprints: [],
  discountCodes: []
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_IMPRINTS] (state, res) {
    state.imprints = res
  },
  [_types.mutations.SET_DISCOUNT_CODES] (state, res) {
    state.discountCodes = res
  },
  [_types.mutations.SET_PAGED_IMPRINT_DISCOUNTS] (state, res) {
    state.pagedImprintDiscounts = res
  },
  [_types.mutations.SET_TOTAL_IMPRINT_DISCOUNTS_COUNT] (state, count) {
    state.totalImprintDiscountsCount = count
  },
  [_types.mutations.SET_TABLE_OPTIONS] (state, options) {
    state.tableOptions = options
  },
  [_types.mutations.SET_SEARCH_OPTIONS] (state, options) {
    state.searchOptions = options
  },
  [_types.mutations.SET_IMPRINT_FILTER] (state, filter) {
    state.searchOptions.imprintFilter = filter
  },
  [_types.mutations.SET_DISCOUNT_CODE_FILTER] (state, filter) {
    state.searchOptions.discountCodeFilter = filter
  }
}

const actions = {
  [_types.actions.fetchImprintDiscountsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    const { keyword, imprintFilter, discountCodeFilter } = state.searchOptions
    const { itemsPerPage, page } = state.tableOptions
    const maxResultCount = itemsPerPage
    const skipCount = (page - 1) * itemsPerPage
    return $http().get(`admin/imprintdiscounts`, {
      params: {
        keyword,
        skipCount,
        maxResultCount,
        imprintFilter,
        discountCodeFilter
      }
    })
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_IMPRINT_DISCOUNTS, items)
        commit(_types.mutations.SET_TOTAL_IMPRINT_DISCOUNTS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.fetchImprints] ({ commit }) {
    return $http().get(`admin/imprints/names`)
      .then((res) => {
        commit(_types.mutations.SET_IMPRINTS, res)
      })
  },
  [_types.actions.fetchDiscountCodes] ({ commit }, imprintName) {
    return $http().get(`admin/imprintdiscounts/codes${imprintName ? `?imprintName=${imprintName}` : ''}`)
      .then((res) => {
        commit(_types.mutations.SET_DISCOUNT_CODES, res)
      })
  },
  [_types.actions.changeImprintFilter] ({ state, commit, dispatch }, value) {
    commit(_types.mutations.SET_IMPRINT_FILTER, value)
  },
  [_types.actions.changeDiscountCodeFilter] ({ state, commit, dispatch }, value) {
    commit(_types.mutations.SET_DISCOUNT_CODE_FILTER, value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
